import { ymdIsAfter, ymdNow } from '@/database/yearMonthDayUtil';
import { YearMonthDay } from '@shared/types';

export const validateEarnedYmd = (
  value: YearMonthDay | undefined,
): string | undefined => {
  if (!value) {
    return 'Date is required';
  }
  if (ymdIsAfter({ ymd: value, other: ymdNow() })) {
    return 'Earned date cannot be in the future';
  }
  return undefined;
};

export const validateHours = (
  value: number | undefined,
): string | undefined => {
  if (value === undefined || value === null) {
    return 'Hours is required';
  }
  if (isNaN(value)) {
    return 'Hours is not a valid number';
  }
  if (value < 0) {
    return 'Hours must be greater than or equal to 0';
  }
  return undefined;
};

export const validateRate = (
  value: number | undefined,
  matterType: string | undefined,
): string | undefined => {
  if (matterType !== 'Hourly') {
    return undefined;
  }
  if (value === undefined || value === null) {
    return 'Rate is required for hourly matters';
  }
  if (isNaN(value)) {
    return 'Rate is not a valid number';
  }
  if (value < 0) {
    return 'Rate must be greater than or equal to 0';
  }

  return undefined;
};

export const validateMatterId = (value: string): string | undefined => {
  if (!value) {
    return 'Matter is required';
  }
  return undefined;
};

export const validateDescription = (value: string): string | undefined => {
  if (!value) {
    return 'Description is required';
  }
  return undefined;
};

export const validateUserId = (value: string): string | undefined => {
  if (!value) {
    return 'User is required';
  }
  return undefined;
};
